import { Editor } from "prism-react-editor";
import { BasicSetup } from "prism-react-editor/setups";

// Adding the grammar
import "prism-react-editor/prism/languages/jsx";

// Adds comment toggling and auto-indenting
import "prism-react-editor/languages/html";
import "prism-react-editor/languages/json";

import "prism-react-editor/layout.css";
import "prism-react-editor/themes/github-dark.css";

// Required by the basic setup
import "prism-react-editor/search.css";

function EditorBlock({
  content,
  setContent,
  readOnly = true,
}: {
  content: string;
  setContent: (text: string) => void;
  readOnly?: boolean;
}) {
  let readOnlyColors = {};
  if (readOnly) {
    readOnlyColors = {
      "--editor__bg": "#8b8b8bff",
    } as React.CSSProperties;
  }

  return (
    <Editor
      language="jsx"
      value={content}
      onUpdate={(text) => {
        setContent(text);
      }}
      readOnly={readOnly}
      wordWrap={true}
      style={readOnly ? readOnlyColors : undefined}
    >
      {(editor) => <BasicSetup editor={editor} />}
    </Editor>
  );
}

export default EditorBlock;
